// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3BSBL","head":"Table_head__syrF0","col":"Table_col__1rFBC"};